import { HttpClient } from '../../httpClient'
import { OpalApi, OpalApiResponseDocument } from '../../schema'

type CreateStoryV2 = OpalApi<'CreateStoryV2', 201>
type CreateStoryV2Response = OpalApiResponseDocument<'CreateStoryV2', 201>

export const createStory: CreateStoryV2 = async ({
  requestBody,
}: Parameters<CreateStoryV2>[0] = {}) => {
  const url = new URL('/stories/v2', window.location.origin)

  return HttpClient()
    .post<CreateStoryV2Response>(url.toString(), requestBody)
    .then((res) => res.data)
}
